import React, { Component } from 'react';
import cn from 'classnames';
import moment from 'moment';
import upperFirst from 'lodash/upperFirst';
import { mergeClassNames, withMomentLocale } from '../../utils/utilsGlobal';
import originalStyles from './Datepicker.scss';


export class Datepicker extends Component {

  state = {
    grid: [],
    selectedDate: null,
    gridMonth: null,
    gridYear: null,
    isCalendarVisible: false,
  };

  calendar = React.createRef();

  componentDidMount(){
    this.setData();
    document.body.addEventListener('click', this.onBodyClick);
  }

  componentWillUnmount(){
    document.body.removeEventListener('click', this.onBodyClick);
  }

  setData = () => {
    const { defaultValue } = this.props;
    let selectedDate = null;
    let gridMonth = null;
    let gridYear = null;

    if (defaultValue) {
      selectedDate = new Date(defaultValue);
      gridMonth = selectedDate.getMonth();
      gridYear = selectedDate.getFullYear();
    }
    else {
      gridMonth = new Date().getMonth();
      gridYear = new Date().getFullYear();
    }

    this.setState({
      selectedDate,
      gridMonth,
      gridYear,
      grid: this.generateGridByMonthAndYear(gridMonth, gridYear)
    });
  };

  generateGridByMonthAndYear = (monthIndex, year) => {
    const { availableFrom, availableTo } = this.props;
    const firstDayOfMonth = moment([year, monthIndex, 1]);
    const gridFirstDate = firstDayOfMonth
      .clone()
      .subtract(firstDayOfMonth.day() === 0 ? 6 : firstDayOfMonth.day() - 1, 'days');

    const lastDayOfMonth = firstDayOfMonth.clone().add(1, 'month').subtract(1, 'days');
    const gridLastDate = lastDayOfMonth
      .clone()
      .add(lastDayOfMonth.day() === 0 ? 0 : 7 - lastDayOfMonth.day(), 'days');

    let currentDate = gridFirstDate.clone();
    let grid = [];

    while (currentDate.isSameOrBefore(gridLastDate, 'day')) {
      let isAvailable = true;
      if (availableFrom && availableTo) {
        isAvailable = currentDate.isBetween(availableFrom, availableTo, 'day', '[]');
      }
      else if (!availableFrom && availableTo) {
        isAvailable = currentDate.isSameOrBefore(availableTo, 'day');
      }
      else if (!availableTo && availableFrom) {
        isAvailable = currentDate.isSameOrAfter(availableFrom, 'day');
      }
      grid.push({
        date: currentDate.get('date'),
        month: currentDate.get('month'),
        isToday: currentDate.isSame(new Date(), 'day'),
        isSameMonth: currentDate.isSame(moment([year, monthIndex]), 'month'),
        isAvailable: isAvailable,
      });
      currentDate.add(1, 'day');
    }
    return grid;
  };

  onMonthChange = (delta) => {
    const { gridMonth, gridYear } = this.state;
    let nextGridMonth = gridMonth + delta;
    let nextGridYear = gridYear;

    if (nextGridMonth > 11) {
      nextGridMonth = 0;
      nextGridYear = gridYear + 1;
    }
    if (nextGridMonth < 0) {
      nextGridMonth = 11;
      nextGridYear = gridYear - 1;
    }
    const nextGrid = this.generateGridByMonthAndYear(nextGridMonth, nextGridYear);
    this.setState({
      gridMonth: nextGridMonth,
      gridYear: nextGridYear,
      grid: nextGrid,
    });
  };

  onDateClick = (date, month) => {
    const { onChange } = this.props;
    const { gridYear, selectedDate } = this.state;
    const newSelectedDate = moment([gridYear, month, date]).toDate();

    if (!moment(newSelectedDate).isSame(selectedDate, 'day')) {
      this.setState({
        selectedDate: newSelectedDate,
        isCalendarVisible: false,
      });
      onChange(newSelectedDate);
    }
  };

  getDisplayMonthName = () => {
    const { gridMonth } = this.state;
    return withMomentLocale('ru', () => {
      return upperFirst(moment().month(gridMonth).format('MMMM'));
    });
  };

  onValueClick = () => {
    this.setState({ isCalendarVisible: true });
  };

  onBodyClick = (e) => {
    if (!this.calendar.current?.contains?.(e.target) && e.target !== this.calendar.current) {
      this.setState({ isCalendarVisible: false });
    }
  };

  render(){
    const { className, overrideClassNames, children, onClick } = this.props;
    const { grid, selectedDate, gridYear, isCalendarVisible } = this.state;
    const styles = mergeClassNames(originalStyles, overrideClassNames);

    if (!grid.length) {
      return null;
    }

    return (
      <div className={cn(styles.container, className)} onClick={onClick}>
        <span className={styles.button} onClick={this.onValueClick}>
          {children}
        </span>

        {isCalendarVisible && (
          <div className={styles.calendar} ref={this.calendar}>
            <div className={styles.calendarHead}>
              <span className={styles.prevMonth} onClick={() => this.onMonthChange(-1)}>
                <i className="icon-chevron-down"/>
              </span>
              <span className={styles.currentMonth}>{this.getDisplayMonthName()}</span>
              <span className={styles.nextMonth} onClick={() => this.onMonthChange(1)}>
                <i className="icon-chevron-down"/>
              </span>
            </div>
            <ul className={styles.gridContainer}>
              <li className={styles.gridHead}>Пн</li>
              <li className={styles.gridHead}>Вт</li>
              <li className={styles.gridHead}>Ср</li>
              <li className={styles.gridHead}>Чт</li>
              <li className={styles.gridHead}>Пт</li>
              <li className={styles.gridHead}>Сб</li>
              <li className={styles.gridHead}>Вс</li>
              {grid.map((day, i) => (
                <li className={cn({
                  [styles.gridDate]: true,
                  [styles.gridDateToday]: day.isToday,
                  [styles.gridDateAnotherMonth]: !day.isSameMonth,
                  [styles.gridDateNotAvailable]: !day.isAvailable,
                  [styles.gridDateSelected]: moment([gridYear, day.month, day.date]).isSame(selectedDate, 'date'),
                })}
                  onClick={() => day.isAvailable && this.onDateClick(day.date, day.month)}
                  key={i}>
                  {day.date}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );
  }
}
